module.exports = __webpack_public_path__ + "e048455183debbae6d8e7f5e4201def7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/clean-200-icon.png
// module id = 301
// module chunks = 0